import React from 'react';
import { LinkClear } from './styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getFieldFromUsers = (items: any[], field: string) => {
  const len = items.length;
  if (len === 0) return '';
  const fieldValues = items.map(user => user[field]);
  return `(${len}) ${fieldValues[0]}`;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PreviewItems: React.FC<{ items: any[]; field: string }> = ({
  items,
  field,
}) => {
  if (!items || items.length === 0) {
    return <LinkClear fontSize="12px !important;">(0) Add new</LinkClear>;
  }
  return (
    <LinkClear fontSize="12px !important;">
      {getFieldFromUsers(items, field)}
    </LinkClear>
  );
};

export default PreviewItems;
